



























import mixins from '../../mixins';
import interactable from '../../mixins/interactable/interactable';
import validatable from '../../mixins/validatable/validatable';

export default mixins(interactable, validatable).extend({
  mixins: [interactable, validatable],
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, default: undefined },
    color: { type: String, default: 'interaction-darken-1' },
  },
  data: () => ({
    navigatedUsingKeyboard: false,
  }),
  computed: {
    classList() {
      return {
        'p-checkbox': true,
        'keyboard-focus': this.navigatedUsingKeyboard,
        invalid: (this.innerErrors ?? []).length > 0,
        disabled: this.disabled,
        readonly: this.readonly,
      };
    },
    inputClassList() {
      return {
        [`color-${this.color}`]: this.color && !this.disabled && !this.readonly && this.value,
        // [`border-color-${this.color}`]: this.color && !this.disabled && !this.readonly && this.value,
        'text-color-disabled': this.disabled || this.readonly,
      };
    },
  },
  methods: {
    onChange(event: InputEvent) {
      const target = event.target as HTMLInputElement;
      const { checked } = target;
      this.$emit('input', checked);
    },
    onKeyup() {
      this.navigatedUsingKeyboard = true;
    },
    onClickOutside() {
      // When clicking on label no blur event should happen
      this.$emit('blur');
    },
    onBlur() {
      this.navigatedUsingKeyboard = false;
      if (this.value) {
        // Only blur if we're checked so invalid states and such get reset
        this.$emit('blur');
      }
    },
  },
});
